import React from "react"
import styled from "styled-components"
import Img from "gatsby-image"
import { device } from "../../themes/device"

const Image = styled(Img)`
  border-radius: 50%;
  width: 80%;
  margin: 0 auto 40px auto;

  @media ${device.tablet} {
    width: 75%;
    display: block;
  }
`

export default Image
